<template>
	<!-- Accueil -->
	<section v-if="section.type === 'root'" class="section accueil">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
				<div class="oims_button">
					<span>{{appConstants.translations[locale].oimsButton}}</span>
					<a href="https://oims.ch/" target="_blank">OIMS
						<svg xmlns="http://www.w3.org/2000/svg" width="7.753" height="12.678">
						  <path fill="#fff" d="M1.414 12.678 0 11.264l4.925-4.925L0 1.414 1.414 0l6.339 6.339Z"/>
						</svg>
					</a>
				</div>
			</div>
			<div v-if="section.content" class="content staggerTo in-view" v-html="splited(section.content)"></div>
			<div class="twitter-wrapper" v-if="tweets">
				<div class="container__inner">
					<div  class="owl-carousel owl--fullscreen owl-theme" v-owl:viewOptions="{dots: true}">
						<div v-for="tweet in tweets" :key="tweet.id" class="tweet">
							<a :href="'https://twitter.com/'+tweet.username" target="_blank" class="follow__twitter"><span>{{appConstants.translations[locale].follow}}</span></a>
							<div class="title">
								<img class="user-logo" :src="tweet.userimage" alt="Logo User Twitter">
								<div class="username"><h4>{{tweet.name}}</h4> <span>@{{tweet.username}} <img v-if="tweet.verified === true" src="/images/verified.svg" alt=""></span></div>
							</div>
							<div class="tweet-text">
								<p>{{tweet.text}}</p>
							</div>
							<div class="tweet-details">
								<div class="info">
									<span class="retweet"><img src="/images/retweet.svg" alt=""> {{tweet.retweets}}</span>
									<span class="favorite"><img src="/images/favorite.svg" alt=""> {{tweet.favorite}}</span>
									<span class="link"><a :href="tweet.link" target="_blank"><img src="/images/link.svg" alt=""></a></span>
								</div>
								<div class="date">
									<span>{{tweet.date | formatDate('HH:MM - DD MMMM YYYY', 'ddd MMM DD hh:mm:ss ZZ YYYY')}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="timeline__wrapper">
				<a href="#" ref="hiddenEl" class="hiddenEl"></a>
				<div class="timeline__tabs">
					<a href="#" v-for="page in removeDuplicateYear(section.collections[0].pages)" :key="page.id" v-scroll-to="'#id'+page.id" :class="{'active': page.id === selectedPage}" @click.prevent="selectedPage = page.id">{{page.fields.year.value}}</a>
				</div>
				<div class="timeline__pages">
					<h2 v-if="section.fields.timeline_title && section.fields.timeline_title.value">{{section.fields.timeline_title.value}}</h2>
					<div class="timeline__page" v-for="page in orderByYear(section.collections[0].pages)" :id="'id'+page.id" :key="page.id">
						<h3 class="hidden-desktop-xs">{{page.title}}</h3>
						<div class="timeline__page__bg in-view" data-delay="100" data-animation="in-view-up">
							<div v-if="page.fields.image && page.fields.image.value && page.fields.image.value" :style="{'background-image': 'url(' + smallThumbnailUrl(page.fields.image.value[0]) + ')'}"></div>
						</div>
						<div class="timeline__page__content in-view" data-delay="200" data-animation="in-view-up">
							<h3 class="hidden-mobile-xs">{{page.title}}</h3>
							<div v-html="page.content"></div>
						</div>
					</div>
				</div>	
			</div>
		</div>
	</section><!--End of Accueil -->

	<!-- A Propos -->
	<section v-else-if="section.type === 'propos'" class="section propos">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length > 0 && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content page-content--blue__links in-view" data-simplebar>
						<div v-html="page.content"></div>
					</div>
					<span class="page-content__gradient"></span>
				</div>
			</div>
		</div>
	</section><!--End of A Propos -->

	<!-- OIMS -->
	<section v-else-if="section.type === 'oims'" class="section oims">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length > 0 && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
    				<div class="page-content page-content--blue__links in-view" data-simplebar>
						<h2>{{page.title}}</h2>
						<div v-html="page.content"></div>
					</div>
					<span class="page-content__gradient"></span>
				</div>
			</div>
		</div>
	</section><!--End of OIMS -->
	
	<!-- Activites -->
	<section v-else-if="section.type === 'activites'" class="section activites">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length > 0 && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content page-content--blue__links in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
						<a class="pdf-link" target="_blank" v-if="page.fields.pdf_file && page.fields.pdf_file.value" :href="'/uploads/' + page.fields.pdf_file.value[0]"><img src="/images/pdf.svg" alt=""><span v-html="appConstants.translations[locale].pdfFile"></span> </a>
					</div>
					<span class="page-content__gradient"></span>
				</div>                
			</div>
		</div>
	</section><!--End of Activites -->

	<!-- Nos Valeurs -->
	<section v-else-if="section.type === 'nos_valeurs'" class="section nos__valeurs">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content page-content--blue__links in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
					</div>
					<span class="page-content__gradient"></span>
				</div> 
			</div>
		</div>
	</section><!--End of Nos Valeurs -->  

	<!-- Notre Vision -->
	<section v-else-if="section.type === 'notre_vision'" class="section notre_vision">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" v-if="page.tags.length == 0" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content page-content--blue__links in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
						<a :href="extraInfo.title" 
						class="extra-info" 
						v-for="(extraInfo, index) in section.collections[0].pages"
						:key="index" 
						v-if="extraInfo.tags.length > 0 && page.title == extraInfo.tags[0].name"
						@click.stop.prevent="extraInfoPopup = extraInfo">{{extraInfo.title}}</a>
						<div v-if="page.fields.pdf && page.fields.pdf.value" v-html="page.fields.pdf.value"></div>
					</div>
					<span class="page-content__gradient"></span>
				</div> 
			</div>
		</div>
		<transition name="fade">
			<div class="extra-info-popup" v-if="extraInfoPopup">
				<div class="extra-info-popup__block" @click.stop>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.987 32.987" @click="extraInfoPopup = null">
						<g transform="translate(14470.5 -1782.5)">
							<circle class="a" cx="15.494" cy="15.494" r="15.494" transform="translate(-14469.5 1783.5)" />
							<line class="b" y1="12.702" x2="12.702" transform="translate(-14460.354 1792.646)" />
							<line class="b" x1="12.702" y1="12.702" transform="translate(-14460.354 1792.646)" />
						</g>
					</svg>
					<div class="body">
						<p class="title">{{extraInfoPopup.title}}</p>
						<div class="description" v-html="extraInfoPopup.content"></div>
						<div v-if="extraInfoPopup.fields.pdf && extraInfoPopup.fields.pdf.value" v-html="extraInfoPopup.fields.pdf.value"></div>
					</div>
				</div>
			</div>
		</transition>
	</section><!--End of Notre Vision -->  


	<!-- Notre Vision -->
	<section v-else-if="section.type === 'enngagement'" class="section enngagement">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
					</div>
					<span class="page-content__gradient"></span>
				</div> 
			</div>
		</div>
	</section><!--End of Notre Vision -->
	

	<!-- References -->
	<section v-else-if="section.type === 'references'" class="section references">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div class="container__inner">
				<div v-if="testimonials.length > 0" class="content" v-html="section.content"></div>
				<div class="pages" v-if="testimonials">
					<div class="page in-view in-view-up" v-for="testimonial in limitedTestimonial" :key="testimonial.id" v-if="testimonial.status === 1">
						<div class="testimonial__wrapper">
							<h2>{{testimonial.first_name}}</h2>
							<h3>{{testimonial.created_at | formatDate('MMMM YYYY', 'YYYY-MM-DD hh:mm:ss')}}</h3>
							<br>
							<div class="page-content" v-html="testimonial.message"></div>
						</div>
					</div>
				</div>
				<a v-if="!loadAll" href="#" @click.prevent="loadAll = true" class="loadmore">Afficher d’avantage</a>
			</div>
			<div class="form">
				<h2 v-html="appConstants.translations[locale].writeTestimonial"></h2>
				<form @submit.prevent="sendTestimonial">
					<div class="inputs">
						<div>
							<input type="text" :name="appConstants.translations[locale].form.last_name" :id="appConstants.translations[locale].form.last_name" :autocomplete="appConstants.translations[locale].form.last_name" :placeholder="appConstants.translations[locale].form.last_name + '*'" required v-model="testimonial.last_name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has(appConstants.translations[locale].form.last_name) }">
							<p v-if="errors.has(appConstants.translations[locale].form.last_name)" class="help is-danger">{{ errors.first(appConstants.translations[locale].form.last_name) }}</p>                            
						</div>
						<div>
							<input type="text" :name="appConstants.translations[locale].form.first_name" :id="appConstants.translations[locale].form.first_name" :autocomplete="appConstants.translations[locale].form.first_name" :placeholder="appConstants.translations[locale].form.first_name + '*'" required v-model="testimonial.first_name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has(appConstants.translations[locale].form.first_name) }">
							<p v-if="errors.has(appConstants.translations[locale].form.first_name)" class="help is-danger">{{ errors.first(appConstants.translations[locale].form.first_name) }}</p>                            
						</div>                        
					</div>
					<div class="inputs">
						<div>
							<input type="email" name="email" id="email" autocomplete="email" placeholder="E-mail*" required v-model="testimonial.email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }">
							<p v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>                            
						</div> 
						<div>
							<input type="text" name="phone" id="phone" autocomplete="phone" :placeholder="appConstants.translations[locale].form.phone" required v-model="testimonial.phone">
						</div>                        
					</div>
					<div class="textarea">
						<textarea name="message" id="message" autocomplete="message" rows="10" placeholder="Message" required v-model="testimonial.message" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('message') }"></textarea>
						<p v-if="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</p>
					</div>
					<div class="checkbox" :class="{'input': true, 'is-danger': errors.has('checkbox')}">
						<input type="checkbox" name="checkbox" id="checkbox" v-model="terms" v-validate="'required'">
						<label for="checkbox" v-html="appConstants.translations[locale].terms"></label>
						<p v-if="errors.has('checkbox')" class="help is-danger">{{ errors.first('checkbox') }}</p>
					</div>
					<div class="submit__btn">
						<button type="submit" :disabled="(!testimonial.last_name || !testimonial.email || !testimonial.first_name || !terms || !testimonial.message) || (errors.has(appConstants.translations[locale].form.first_name) || errors.has(appConstants.translations[locale].form.last_name) || errors.has('checkbox') || errors.has('email') || errors.has('message'))">Envoyer</button>
					</div>
					<br>
					<p v-html="'* '+ appConstants.translations[locale].required"></p>
					<transition name="fade">
						<div v-if="testimonialResponseMessage" class="responseMessage"><span>{{testimonialResponseMessage}}</span></div>
					</transition>
				</form>
			</div>
		</div>
	</section><!--End of References -->    
	
	<!-- L'èquipe -->
	<section v-else-if="section.type === 'lequipe'" class="section lequipe">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div v-if="section.content" class="content" v-html="section.content"></div>
			<div class="zigZag-pages" v-if="section.collections.length && section.collections[0].pages && section.collections[1].pages">
				<h2 class="page__title" v-if="section.collections[0].pages.length > 0">{{appConstants.translations[locale].ourTeam}}:</h2>
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content page-content--blue__links in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
						<a class="social__link" target="_blank" :href="page.fields.linkedin_link.value" v-if="page.fields.linkedin_link && page.fields.linkedin_link.value"><i class="icon-linkedin"></i></a>
					</div>
				</div>                     
				<h2 class="page__title" v-if="section.collections[1].pages.length > 0">{{appConstants.translations[locale].ourTeam}}, <br> à Lugano</h2>
				<div class="page in-view" v-for="page in section.collections[1].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content page-content--blue__links in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
						<a class="social__link" target="_blank" :href="page.fields.linkedin_link.value" v-if="page.fields.linkedin_link && page.fields.linkedin_link.value"><i class="icon-linkedin"></i></a>
					</div>
					<span class="page-content__gradient"></span>
				</div>
			</div>
		</div>
	</section><!--End of L'èquipe -->

	<!-- Contact -->
	<section v-else-if="section.type === 'contact'" class="section contact">
		<div class="container">
			<div class="background-wrapper"  
				:class="{'dark-text': section.fields.dark_text_on_background_image.value === '1'}" v-show="section.fields.image && section.fields.image.value">
				<div class="background-image lazy"  v-if="section.fields.dark_text_on_background_image && section.fields.image && section.fields.image.value" v-lazy:background-image="fullScreenUrl(section.fields.image.value[0])"></div>
				<div class="image-text in-view in-view-scale" v-if="section.fields.image_text.value">{{section.fields.image_text.value}}</div>
				<span class="scroll-down in-view in-view-fade">scroll down</span>
			</div>
			<div class="zigZag-pages" v-if="section.collections.length > 0 && section.collections[0].pages">
				<div class="page in-view" v-for="page in section.collections[0].pages" :key="page.id" data-delay="100" data-animation="in-view-up">
					<div class="page-img">
						<div class="mask"></div>
						<div class="background-image lazy"  v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]"  v-lazy:background-image="fullScreenUrl(page.fields.image.value[0])"></div>
					</div>
					<div class="page-content in-view" data-delay="300" data-animation="in-view-up" data-simplebar>
						<div v-html="page.content"></div>
						<a class="pin" target="_blank" :href="page.fields.map_link.value" v-if="page.fields.map_link && page.fields.map_link.value"><span>Voir sur la carte</span><img src="/images/pin.svg" alt=""></a>
					</div>
				</div>
			</div>
			<div class="form">
				<h2 v-html="appConstants.translations[locale].getInTouch"></h2>
				<form @submit.prevent="sendEmail">
					<div class="inputs">
						<div>
							<input type="text" :name="appConstants.translations[locale].form.last_name" :id="appConstants.translations[locale].form.last_name" :autocomplete="appConstants.translations[locale].form.last_name" :placeholder="appConstants.translations[locale].form.last_name + '*'" required v-model="user.lastname" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has(appConstants.translations[locale].form.last_name) }">
							<p v-if="errors.has(appConstants.translations[locale].form.last_name)" class="help is-danger">{{ errors.first(appConstants.translations[locale].form.last_name) }}</p>
						</div>
						<div>
							<input type="text" :name="appConstants.translations[locale].form.first_name" :id="appConstants.translations[locale].form.first_name" :autocomplete="appConstants.translations[locale].form.first_name" :placeholder="appConstants.translations[locale].form.first_name + '*'" required v-model="user.name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has(appConstants.translations[locale].form.first_name) }">
							<p v-if="errors.has(appConstants.translations[locale].form.first_name)" class="help is-danger">{{ errors.first(appConstants.translations[locale].form.first_name) }}</p>                            
						</div>                        
					</div>
					<div class="inputs">
						<div>
							<input type="email" name="email" id="email" autocomplete="email" placeholder="E-mail*" required v-model="user.email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }">
							<p v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>                            
						</div> 
						<div>
							<input type="text" name="tel" id="tel" autocomplete="tel" :placeholder="appConstants.translations[locale].form.phone" required v-model="user.tel">
						</div>                        
					</div>
					<div class="textarea">
						<textarea name="message" id="message" autocomplete="message" rows="10" placeholder="Message" required v-model="user.message" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('message') }"></textarea>
						<p v-if="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</p>
					</div>
					<div class="submit__btn">
						<button type="submit" :disabled="(!user.lastname || !user.email || !user.name || !user.message) || (errors.has(appConstants.translations[locale].form.first_name) || errors.has(appConstants.translations[locale].form.last_name) || errors.has('checkbox') || errors.has('email') || errors.has('message'))">Envoyer</button>
					</div>
					<br>
					<p v-html="'* '+ appConstants.translations[locale].required"></p>
					<transition name="fade">
						<div v-if="contactResponseMessage" class="responseMessage"><span>{{contactResponseMessage}}</span></div>
					</transition>
				</form>
			</div>
		</div>
	</section><!--End of Contact -->              

</template>

<script>
	import Vue from 'vue'
	import _find from 'lodash/find'
	import _orderBy from 'lodash/orderBy'
	import _uniqBy from 'lodash/uniqBy'
	import { mapState } from 'vuex';
	import inViewCustom from '../inViewCustom'
	import { Owl } from '../directives/owl-carousel'
	import fecha from 'fecha';
	import _throttle from 'lodash/throttle'
	import Simplebar from 'simplebar';
	// Vue.use(Simplebar)
	// fecha.i18n = {
	// 	dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	// 	dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
	// 	monthNamesShort: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai' ,'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
	// 	monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
	// }
	
	export default {
		name: 'SectionComponent',
		directives: {
			Owl
		},
		components: {
			Simplebar
		},
		created () {
			this.fetchData()
			document.addEventListener('scroll', _throttle(this.stickyTabs, 100))
		},
		mounted() {
			inViewCustom()
			this.animations()
			this.$nextTick(()=> {
				if (this.section.type === 'root') {
					this.hashTagColor()
				}
			})
			window.addEventListener('click', () => {
				this.extraInfoPopup = null;
				$('html > body').removeClass('popup-extra-info')
			})
		},
		watch: {
			extraInfoPopup: function(val) {
				if(val != null) {
					this.$nextTick(() => {
						new SimpleBar(document.querySelector('.extra-info-popup__block .body'));
					})
					$('html > body').addClass('popup-extra-info')
				} else {
					$('html > body').removeClass('popup-extra-info')
				}
			}			
		},
		destroyed() {
			inViewCustom()
		},
		data () {
			return {
				locale: this.$route.params.locale,
				selectedPage: '',
				params: {
					title: '',
					description: '',
					descriptionTwitter: '',
					titleTwitter: '',                
					descriptionFacebook: '',
					titleFacebook: '',
					image: '',
					imageTwitter: '',
					imageFacebook: '',
					linkCanonical: ''
				},
				testimonial: {
					first_name: '',
					last_name: '',
					email: '',
					phone: '',
					message: '',
				},
				terms: false,
				testimonialResponseMessage: '',
				user: {
					name: '',
					lastname: '',
					email: '',
					tel: '',
					message: ''
				},
				contactResponseMessage: '',
				loadAll: false,
				extraInfoPopup: null
			}
		},
		head: {
			title: function () {
				return {
					inner: this.params.title,
					separator: ' '
				}
			},
			meta: function () {
				return [
					{ n: 'description', c: this.params.description},
					{ n: 'keywords', c: this.params.keywords},
					{ n: 'twitter:title', c: this.params.titleTwitter},
					{ n: 'twitter:description', c: this.params.descriptionTwitter},
					{ n: 'twitter:image', c: `${url}/uploads/${this.params.imageTwitter}`},
					{ p: 'og:title', c: this.params.titleFacebook },
					{ p: 'og:description', c: this.params.descriptionFacebook},
					{ p: 'og:image', c: `${url}/uploads/${this.params.imageFacebook}`},
					{ p: 'og:url', h: `${url}`}
				]
			},
			link: function() {
				return [
					{ r: 'canonical', h: this.params.linkCanonical}
				]
			}
		},
		methods: {
			hashTagColor() {
				const regex = /\W(\#[a-zA-Z-àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+\b)(?!;)/g
				$(".twitter-wrapper .tweet-text p").html(function(_, html){
					return html.replace(regex, ' <span class="hashSign">$1</span> ');   
				});
			},
			fetchData () {
				this.params = this.formatMeta(this.section)
				this.$nextTick( () => {
					this.$emit('updateHead')
				})
			},
			sendTestimonial (e) {
				this.$validator.validateAll().then(result => {
					if (result) {
						axios.post('api/v2/testimonials/save', this.testimonial)
							.then((response) => {
								this.testimonialResponseMessage = 'Thank you!'
								setTimeout(() => {
									this.testimonialResponseMessage = ''
									this.testimonial = {}
									this.$validator.reset()
								},2500)
							})
							.catch((error) => {
								this.testimonialResponseMessage = 'Sorry! Try again!'
							})
					} else {
						// validation failed
						console.log('invalid form')
					}
				}).catch((err) => {
					// something went wrong
					console.log(err)
				});
			},
			sendEmail: function (e) {
				this.$validator.validateAll().then(result => {
					if (result) {
						axios.post('/api/v2/mail/send', this.user)
							.then(response => {
								this.contactResponseMessage = 'Thank you for sending your message'
								setTimeout(() => {
									this.contactResponseMessage = ""
									this.user = {}
									this.$validator.reset()
								}, 2500)
							})
							.catch(error => {
								this.contactResponseMessage = 'I apologize for this inconvenience but there seems to have been an error when sending. Would it be possible to retransmit'
							})
					} else {
						// validation failed
						console.log('invalid form')
					}
				}).catch(() => {
					// something went wrong
				});
			},
			animations() {
				var tl = new TimelineMax()
				this.$nextTick(() => {
					let staggerToElement = document.querySelectorAll('.staggerTo.in-view *')
						tl
						.set(staggerToElement, {opacity: 0, y: -5})
						.staggerTo(staggerToElement, 0.2, {opacity: 1, y: 0}, 0.05, 0.1);

					let bg = document.querySelector('.background-image')
					let txt = document.querySelector('.image-text')

					if (bg) {
						let timeL = new TimelineLite;
						timeL
							.to(bg, 5, {scale: 1.1,rotationZ: '0.01deg',z: 0.1}, 0.2);
					}
					if (txt) {
						let timeL = new TimelineLite, 
							mySplitText = new SplitText(".image-text", {type:"words,chars"}), 
							chars = mySplitText.chars;

						TweenLite.set(".image-text", {perspective:500});

						timeL
							.staggerFrom(chars, 0.8, {opacity:0, y:50, ease:Back.easeOut}, 0.01, "+=0")
					}
				})
			},
			orderByYear: function (pages) {
				var ordered = []

				if (pages) {
					pages.forEach(function (item) {
						item.year = item.fields.year.value
					})

					ordered = _orderBy(pages, ['year'], ['asc'])
				}
				return ordered
			},
			removeDuplicateYear: function (pages) {
				var ordered = []

				if (pages) {
					pages.forEach(function (item) {
						item.year = item.fields.year.value
					})

					ordered = _orderBy(pages, ['year'], ['asc'])
				}
				return _uniqBy(ordered, 'year')
			},						
            stickyTabs() {
				if(this.$route.params.sectionSlug === 'accueil' || this.$route.params.sectionSlug === 'home') {
					let tabs = $('.timeline__tabs')
					let el = document.querySelector('.hiddenEl')
					let elYOffset = el.getBoundingClientRect().top
					let tabsHeight = $(tabs).height() / 2

					if ( window.innerWidth > 480 && elYOffset < (window.innerHeight / 2 - 200 - tabsHeight)) {
						tabs.addClass('sticky')
						tabs.css('top', `calc(50vh - ${tabsHeight}px)`)
					} else {
						tabs.removeClass('sticky')
						tabs.css('top', 'auto')
					}
					if(tabs.offset().top + tabs.height()  >= $('#footer').offset().top - 10)
						tabs.addClass('bottom');
					if($(document).scrollTop() + (window.innerHeight / 2 + tabsHeight) < $('#footer').offset().top)
						tabs.removeClass('bottom');
				}
			}		
		},
		filters: {
			formatDate: function (date, outputFormat, inputFormat) {
				let _date = fecha.parse(date, inputFormat);

				return fecha.format(_date, outputFormat);
			}
		},
		computed: {
			...mapState([
				'tweets',
				'testimonials',
				'sections'
			]),
			section() {
				return _find(this.sections, {slug: this.$route.params.sectionSlug})
			},
			limitedTestimonial () {
				var limitedTestimonial = []
				if(this.loadAll === false) {
					if($(window).width() > 768 && this.testimonials.length > 4) {
						return limitedTestimonial = this.testimonials.slice(0,4)
					} else if (this.testimonials.length > 2){
						return limitedTestimonial = this.testimonials.slice(0,2)
					}
				} else {
					return limitedTestimonial = this.testimonials
				}
			}
		}	
	}
</script>